<template>
    <u-select-filled-tile v-model="modelValue" v-bind="$attrs" @input="emit">
        <template #append>
            <icon-arrow-secondary size="xx-large" direction="down" class="grey--text text--darken-4" />
        </template>
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-select-filled-tile>
</template>

<script>
import IconArrowSecondary from "@/components/publish/parents/icons/icon-arrow-secondary.vue";
import USelectFilledTile from "@/components/publish/styles/forms/u-select-filled-tile.vue";

export default {
    components: {
        IconArrowSecondary,
        USelectFilledTile,
    },
    props: {
        value: { type: String, default: null },
    },
    data: () => ({
        modelValue: null,
    }),
    methods: {
        sync() {
            this.modelValue = this.value;
        },
        emit() {
            this.$emit("input", this.modelValue);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
